import * as types from "../../actions/ActionTypes";

const initialState = {
    loading: false,
    data: null,
    error: null,
    success: false,
};

const postOfferReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.POST_OFFER_START:
            return { ...state, loading: true, error: null };

        case types.POST_OFFER_SUCCESS:
            return { ...state, loading: false,success:true, data: action.payload, error: null };

        case types.POST_OFFER_ERROR:
            return { ...state, loading: false, error: action.payload };

        case types.POST_OFFER_RESET:
            return initialState;

        default:
            return state;
    }
};

export default postOfferReducer;
